// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"80":"486b713e","164":"225dbbd0","312":"445c9b13","508":"ff8d1a26","588":"fae49a51","636":"cc7c3d68","840":"b37d0e91"}[chunkId] + ".js";
};